/**
 * If the given URL has a leading slash, replace it with the given root.
 */
export function replaceLeadingSlashWithRoot(url: string, root: string) {
  if (url.startsWith("/")) {
    return root + url.slice(1);
  }
  return url;
}
